export const getError = (errors, name) => {
  if (!errors || !name || typeof name !== 'string') return null;

  const keys = name.split('.');
  let error = errors;
  for (let key of keys) {
    if (!error[key]) return null;
    error = error[key];
  }
  return error;
};